<div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="headlines">
        <span class="text-headline-title">
            {{ sorryTitle | translate }}
        </span>
        <span class="text-headline-subtitle">{{ sorrySubTitle | translate }}</span>
        <span class="info">{{ sorryInfo | translate }} </span>
    </div>
</div>
